import { render, staticRenderFns } from "./businessinfo.vue?vue&type=template&id=3134b391&"
import script from "./businessinfo.vue?vue&type=script&lang=js&"
export * from "./businessinfo.vue?vue&type=script&lang=js&"
import style0 from "./businessinfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports